import { InjectionToken } from '@angular/core';

/** Content API endpoint url token */
export const CONTENT_API_TOKEN: InjectionToken<string> = new InjectionToken(
  'Content API endpoint url',
);

// TODO won't be needed once we have proper proxy
/** Content API endpoint url token */
export const LEGACY_CONTENT_API_TOKEN: InjectionToken<string> = new InjectionToken(
  'Legacy Content API endpoint url',
);
